import { useIntl } from 'react-intl';
import * as stylex from '@stylexjs/stylex';
import '@astryxdesign/core/theme/tokens.stylex';
import { spacingVars } from '@astryxdesign/core/theme/tokens.stylex';
import { Token } from '@astryxdesign/core/Token';
import { useMediaQuery } from '@astryxdesign/core/hooks';
import type { FilterNode } from '@qronstat/shared';
import { useApp } from '../../app/context';
import { mobileQuery } from '../../app/layout';
import { nodeLabel } from './model';
const mobileVisible = 2;
export function FilterChips({
  filters,
  realOnly,
  onRemove,
  onClearRealOnly,
  onOpen
}: {
  filters: FilterNode[];
  realOnly: boolean;
  onRemove: (index: number) => void;
  onClearRealOnly: () => void;
  onOpen: () => void;
}) {
  const intl = useIntl();
  const {
    meta,
    locale
  } = useApp();
  const isMobile = useMediaQuery(mobileQuery);
  const chips = filters.map((f, i) => ({
    key: `f${i}`,
    label: nodeLabel(f, meta, intl, locale),
    remove: () => onRemove(i)
  }));
  if (!realOnly) chips.unshift({
    key: 'all',
    label: intl.formatMessage({
      id: 'filters.includingService'
    }),
    remove: onClearRealOnly
  });
  if (!chips.length) return null;
  const visible = isMobile ? chips.slice(0, mobileVisible) : chips;
  const hidden = chips.length - visible.length;
  return <div className="x78zum5 xzye2dw xw2csxc x1rohswg xu0wf1k xozqiw3 xeuugli" role="list" aria-label={intl.formatMessage({
    id: 'filters.active'
  })}>
      {visible.map(c => <span role="listitem" key={c.key}>
          <Token label={c.label} size="sm" onRemove={c.remove} />
        </span>)}
      {hidden > 0 ? <span role="listitem">
          <Token label={`+${hidden}`} size="sm" onClick={onOpen} description={intl.formatMessage({
        id: 'filters.showAll'
      })} />
        </span> : null}
    </div>;
}